import { Validator, NG_VALIDATORS, FormControl } from '@angular/forms';
import { Directive } from '@angular/core';
import { validateMobile } from '@nx-ng/util';

@Directive({
  selector: '[nxNgMobileValid]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MobileValidatorDirective,
      multi: true,
    },
  ],
})
export class MobileValidatorDirective implements Validator {
  validate(c: FormControl) {
    const value: string = c.value;

    const isValid = validateMobile(value);
    if (!isValid) {
      return {
        mobileInvalid: true,
      };
    }
    return null;
  }
}
